import axios from "axios";
import "./stations-form.css";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaCaretDown } from "react-icons/fa6";

function StationsForm({ onDepartureSelect }) {
  const [tHome] = useTranslation("homePage");
  const [stationText, setStationText] = useState(`${tHome("quote-shipping-form.select-dep-opt")}`);
  const [optionsView, setOptionsView] = useState("");
  const [stations, setStations] = useState([]);

  const {
    register,
  } = useForm();

  let currentLng = "es";
  
  useEffect(() => {
    if(localStorage.getItem('lng')) {
      currentLng = localStorage.getItem("lng")
    }
    getStations()
  }, []);

  const getStations = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/stations?lng=${currentLng}`, {
        headers: {
          authorization: process.env.REACT_APP_PUBLIC_KEY,
        }
      })
      let orderStations = response.data.stations;
      orderStations.sort((a, b) => {
        const isMEXA = a.code_text.startsWith("MEX");
        const isMEXB = b.code_text.startsWith("MEX");

        const isEdoMexA = a.name.toLowerCase().startsWith("edomex");
        const isEdoMexB = b.name.toLowerCase().startsWith("edomex");

        if (isMEXA && !isMEXB) return -1;
        if (!isMEXA && isMEXB) return 1;

        if (isMEXA && isMEXB) {
          if (isEdoMexA && !isEdoMexB) return 1;
          if (!isEdoMexA && isEdoMexB) return -1;
      
          const numA = parseInt(a.code_text.substring(3), 10);
          const numB = parseInt(b.code_text.substring(3), 10);
          return numA - numB;
        }
      
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        
        return 0;
      });
  
      setStations(orderStations);
    } catch (error) {
      console.error(error);
    }
  }

  const handleDeparture = (data) => {
    setOptionsView('');
    setStationText(`${data.name} - (${data.code_text.substring(0, 3)})`)
    onDepartureSelect(data.code_text);
  }

  return(
    <>
      <form>
        <div className="quote-form-station">
          <div className="arr-dep-content inpt1">
            <div 
              className="information" 
              onClick={() => setOptionsView('mex-stations')}
            >
              <div className="input-text">
                <input id="departure" type="text" value={stationText} readOnly {...register("departure", {required: true})} />
              </div>
            </div>

            <div 
              className="arrow" 
              onClick={() => setOptionsView('mex-stations')}
            ><FaCaretDown /></div>

            
            <div className={`options-content ${optionsView === 'mex-stations' ? "departure" : ''}`}>
              {stations.map((city, index) => (
                <div 
                  key={index}
                  className="option-home" 
                  onClick={() => handleDeparture(city)}
                >
                  {city.name} ({city.code_text.substring(0, 3)})
                </div>
              ))}
            </div>
          </div>
        </div>
      </form>
    </>
  )

}

export default StationsForm;